import { INTERAX_COLORS } from '../../../../constants/colors'

export enum OnboardingStepStatus {
  NOT_COMPLETED = 'not-completed',
  COMPLETED = 'completed',
  IN_PROGRESS = 'in-progress'
}

const STATUS_COLOR_MAP: Record<OnboardingStepStatus, string> = {
  [OnboardingStepStatus.NOT_COMPLETED]: INTERAX_COLORS.thunderGrey,
  [OnboardingStepStatus.COMPLETED]: INTERAX_COLORS.green,
  [OnboardingStepStatus.IN_PROGRESS]: INTERAX_COLORS.sun
}

export const getOnboardingStatusColor = (status: OnboardingStepStatus): string => STATUS_COLOR_MAP[status]
